import script from "./RepaymentSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentSummary.vue?vue&type=script&setup=true&lang=ts"

import "./RepaymentSummary.vue?vue&type=style&index=0&id=93466c60&scoped=true&lang=css"
import "@/styles/centered-tooltip.css?vue&type=style&index=1&id=93466c60&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93466c60"]])

export default __exports__